import Vue from 'vue';

import Paginate from 'vuejs-paginate';

import App from './App.vue';

import router from './router/router';

import store from './store/store';

import amplitude from 'amplitude-js';

import RoutesWithPermissions from './router/WithPermissions';
import RoutesWithoutPermissions from './router/WithoutPermissions';
import {firebaseAuth} from "@/firebase";
import {getBrandingOptions} from "@/utils/getBrandingOptions";

const init = () => {
  Vue.prototype.$PUBLIC_PATH = window.STATIC_PATH + 'images';

  Vue.component('paginate', Paginate);

  router.beforeEach(async (to, from, next) => {
    if (to.matched.length < 1 || to.matched.some(({record: {meta: {requiresAuth = undefined} = {}} = {}}) => requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to mono-auth login.
      if (!(await store.dispatch('isLoggedIn'))) {
        const redirectPath = encodeURIComponent(to.fullPath.replace(/^\/(login|error)(\?.+)?$/, ''));
        window.location = getBrandingOptions().constructMonoAuthSignInUrl(redirectPath);
      } else if (to.matched.length < 1) {
        for (let el of router.match('/error').matched) {
          to.matched.push(el)
        }
        to.params.statusCode = 404
        //or use router.history.updateRoute(router.match('/error'))
        next()
      } else {
        next()
      }
    } else {
      next()
    }
  });

  new Vue(Vue.util.extend({router, store}, App)).$mount('#app');
};

store.commit('setState', {variable: 'router', value: router, saveToLocal: false});

(async () => {
  // Make sure that the Vuex store accurately reflects the current authentication state
  firebaseAuth.onAuthStateChanged((user) => {
    store.dispatch('setFirebaseUser', {user});
  });

  await new Promise((resolve) => {
    const amplitudeClient = amplitude.getInstance();
    amplitudeClient.init(window.AMPLITUDE_API_KEY, undefined, {includeReferrer: true, includeUtm: true}, function () {
      let matches = window.STATIC_PATH.match(/\/(\w+)\/(\w+)\/$/);
      amplitudeClient.setVersionName(`web - ${matches ? `${matches[1]} : ${matches[2]}` : 'local'}`);
      store.commit('setState', {variable: 'amplitudeClient', value: amplitudeClient, saveToLocal: false});
      resolve();
    });
  });

  if (await store.dispatch('isLoggedIn')) {
    let promises = [];
    promises.unshift(store.dispatch('fetchEmiotPermissions'));
    promises.unshift(store.dispatch('fetchGlobalPermissions'));

    await Promise.all(promises);

    router.addRoutes(RoutesWithPermissions(store));
    init();
  } else {
    router.addRoutes(RoutesWithoutPermissions());
    init();
  }
})();